import React, { PropTypes, Component } from 'react'
import styled from 'styled-components'
import { Colors, Fonts, Metrics } from '../../Themes'

const Container = styled.div``

const Title = styled.div`
  margin-bottom: ${Metrics.margins.small};
  ${Fonts.style.Label};
  color: ${Colors.black};
`

const Error = styled.div`
  margin-top: ${Metrics.margins.tiny};
  ${Fonts.style.Input};
  color: ${Colors.red};
`

const FormContainer = styled.div`
  width: 100%;
  border-radius: 4px;
  background: ${Colors.white};
  border: ${Metrics.borders.default};
`

const InputContainer = styled.input`
  background: none;
  ${Fonts.style.Input};
  color: ${Colors.black};
  width: 100%;
  min-height: ${Metrics.components.inputFormHeight};
  border: none;
  padding: 0 ${Metrics.margins.small};
  outline: none;

  &::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    height: ${Metrics.components.inputFormHeight};
    color: ${Colors.darkGrey};
  }
  &::-moz-placeholder {
    /* Firefox 19+ */
    height: ${Metrics.components.inputFormHeight};
    color: ${Colors.darkGrey};
  }
  &:-ms-input-placeholder {
    /* IE 10+ */
    height: ${Metrics.components.inputFormHeight};
    color: ${Colors.darkGrey};
  }
  &:-moz-placeholder {
    /* Firefox 18- */
    height: ${Metrics.components.inputFormHeight};
    color: ${Colors.darkGrey};
  }
`

class Input extends Component {
  render () {
    const {
      title,
      error,
      handleChange,
      value,
      name,
      type,
      placeholder,
      required,
      handleBlur,
      className,
      handleKeyPress
    } = this.props

    return (
      <Container className={`inputForm ${className}`}>
        {title && (
          <Title className='inputTitle'>
            {title}
            {required && '*'}
          </Title>
        )}
        <FormContainer
          className='formContainer'
          tabIndex='-1'
          onBlur={handleBlur}>
          <InputContainer
            onKeyPress={handleKeyPress}
            placeholder={placeholder}
            onChange={handleChange}
            name={name}
            type={type}
            value={value}
            required={required}
          />
        </FormContainer>
        {error && <Error className='error'>{error}</Error>}
      </Container>
    )
  }
}

Input.propTypes = {
  name: PropTypes.string,
  title: PropTypes.node,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func,
  width: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string,
  error: PropTypes.string,
  className: PropTypes.string,
  handleKeyPress: PropTypes.func
}

Input.defaultPropTypes = {
  type: 'text',
  value: ''
}
export default Input



// WEBPACK FOOTER //
// ./src/components/Input/index.js